import { CUSTOMER_ACTIONS } from './customerActions';

export const INITIAL_STATE = {
  loading: false,
  address: {
    lookupFields: {
      postcode: '',
      buildingNumber: '',
    },
    addresses: [],
    detail: null,
    selectedAddressReference: '',
    isManualAddress: false,
    manualAddress: {
      addressLineOne: '',
      addressLineTwo: '',
      addressLineThree: '',
      addressLineFour: '',
      postcode: '',
    },
  },
  customerContact: {
    title: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    dateOfBirth: '',
    day: '',
    month: '',
    year: '',
  },
  representativeContact: {
    title: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    dateOfBirth: '',
    day: '',
    month: '',
    year: '',
    relationship: '',
  },
  accountReference: '',
  accountReferencePostcode: '',
  accountReferenceNotKnown: '',
  enrollmentCheck: '',
};

export const customerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOMER_ACTIONS.UPDATE_ENROLLMENT_CHECK: {
      return {
        ...state,
        enrollmentCheck: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_LOOKUP_FIELDS: {
      return {
        ...state,
        address: {
          ...state.address,
          lookupFields: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_ADDRESSES: {
      return {
        ...state,
        address: {
          ...state.address,
          addresses: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_ADDRESS_DETAIL: {
      return {
        ...state,
        address: {
          ...state.address,
          detail: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_SELECTED_ADDRESS_REFERENCE: {
      return {
        ...state,
        address: {
          ...state.address,
          selectedAddressReference: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_IS_MANUAL_ADDRESS: {
      return {
        ...state,
        address: {
          ...state.address,
          isManualAddress: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_MANUAL_ADDRESS: {
      return {
        ...state,
        address: {
          ...state.address,
          manualAddress: action.payload,
        },
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE: {
      return {
        ...state,
        accountReference: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_POSTCODE: {
      return {
        ...state,
        accountReferencePostcode: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_ACCOUNT_REFERENCE_NOT_KNOWN: {
      return {
        ...state,
        accountReferenceNotKnown: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_CUSTOMER_CONTACT_DETAILS: {
      return {
        ...state,
        customerContact: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.UPDATE_REPRESENTATIVE_CONTACT_DETAILS: {
      return {
        ...state,
        representativeContact: action.payload,
      };
    }
    case CUSTOMER_ACTIONS.RESET: {
      return {
        ...INITIAL_STATE,
      };
    }
    default: {
      return state;
    }
  }
};
